module.exports = __webpack_public_path__ + "img/pr-12.56f797ac.png";